import tenantsApi from '../api/tenantsApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  LOAD_UNIT_DATA: 'LOAD_UNIT_DATA',
  LOAD_UNIT_DATA_SUCCESS: 'LOAD_UNIT_DATA_SUCCESS',
  LOAD_UNIT_DATA_NOT_FOUND: 'LOAD_UNIT_DATA_NOT_FOUND',
};

export const actions = {
  loadDetails: () => dispatch => {
    dispatch({ type: types.LOAD_UNIT_DATA });

    return tenantsApi
      .getDetails()
      .then(result => {
        if (result.ok) {
          const unit = result.data;
          return dispatch({ type: types.LOAD_UNIT_DATA_SUCCESS, unit });
        }

        if (result.status === 404) return dispatch({ type: types.LOAD_UNIT_DATA_NOT_FOUND });

        dispatch(notificationActions.showError('Nie udało się pobrać ustawień klienta'));
        return logger.error(result);
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/unitActions.js